import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getAverageRecovery } from '../actions/recoveryAction';


export interface AverageRecoveryState {
  averageRecovery: number | undefined;
  loading: boolean;
  error: string | null;
}

const initialState: AverageRecoveryState = {
  averageRecovery: undefined,
  loading: false,
  error: ''
};

const averageRecoverySlice = createSlice({
  name: 'averageRecovery',
  initialState: initialState,
  reducers: {
    averageRecovery: (state: AverageRecoveryState, action: PayloadAction<number>) => { 
      state.averageRecovery = action.payload;
    }
  },
  extraReducers: (builder) => {
    // load averageRecovery
    builder.addCase(getAverageRecovery.pending, (state: AverageRecoveryState) => {
        state.loading = true
        state.error = null
    }),
    builder.addCase(getAverageRecovery.fulfilled, (state: AverageRecoveryState, { payload }: PayloadAction<number>) => {
        state.loading = false
        state.averageRecovery = payload
    }),
    builder.addCase(getAverageRecovery.rejected, (state: AverageRecoveryState, { payload }: PayloadAction<any>) => {
        state.loading = false
        state.error = payload
    })
  }
});

export const { averageRecovery } = averageRecoverySlice.actions;

export default averageRecoverySlice.reducer;